<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable @change-language="changeLanguage" />

    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: title -->
      <template #cell(title)="{ item }">
        <b-media-custom
          :item="item"
          link="pages-FAQs-categories-edit"
          :lang="currentLanguage"
          class="centerTitle"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import BMediaCustom from '@/components/BMediaCustom/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import '@/components/BDataTable/Elements/TruncateText.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useFAQCategoryList from './useFAQCategoryList'

export default {
  name: 'FAQCategoryList',
  components: {
    BDataTable,
    BMediaCustom,
    DeleteRow,
    EditRow,
    LayoutLoading,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useFAQCategoryList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
}
</script>
